//
//
//
//
//
//

export default {
  name: 'product-card-background-audio',
};
